const PAGE_DEFAULTS = {
  pageTitle: 'Documents',
  pageSubtitle: 'View and manage your main documents and chat files in one place',
  pageIcon: 'LuFolderKanban',
  mainTabLabel: 'Main Documents',
  mainTabIcon: 'LuUpload',
  chatTabLabel: 'Chat Documents',
  chatTabIcon: 'LuMessageSquare',
  searchPlaceholder: 'Search files or folders...',
  foldersTitle: 'Folders',
  emptyTitle: 'No documents found',
  emptySubtitle: 'Documents will appear here once uploaded',
  tableDocumentLabel: 'Document',
  tableDateLabel: 'Date',
  tableActionsLabel: 'Actions',
  breadcrumbHomeLabel: 'Home',
  breadcrumbBackLabel: 'Back',
};

const HELP_DEFAULTS = {
  title: 'Documents',
  icon: 'FaFolder',
  intro: 'Your documents are organized into two categories:',
  categories: [],
};

export const getDocumentsPageMeta = (content) => ({
  ...PAGE_DEFAULTS,
  ...(content || {}),
});

export const getDocumentsHelpSection = (content) => {
  const data = { ...HELP_DEFAULTS, ...(content || {}) };
  const categories = (data.categories || [])
    .filter((item) => item.isActive !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return { ...data, categories };
};
